(function($) {
    if (!document.getElementById('search-form') || typeof window.jQuery !== 'function') {
        return;
    }

    const searchHandler = function() {
        const form = document.querySelector('form#search-form');
        const resultsList = document.querySelector('.results-list');
        const paginationContainer = document.querySelector('#pagination-container');

        if (!form) {
            return;
        }

        const $form = $(form);
        const breadcrumbsContainer = document.querySelector('.breadcrumb-list');

        // Register all usable inputs
        const inputQuery = form.querySelector('input[name="q"]');
        const inputPage = form.querySelector('input[name="page"]');

        const inputOrderBy = form.querySelector('.order input[name="order-by"]');
        const inputOrderDirection = form.querySelector('.order input[name="order-dir"]');
        const inputOrderLabel = form.querySelector('#sortDropdown');
        const inputOrderByVisual = form.querySelectorAll('.order .dropdown-item');

        const inputDate = form.querySelector('.date input[name="date"]');
        const inputDateLabel = form.querySelector('#dateDropdown');
        const inputDateVisual = form.querySelectorAll('.date .dropdown-item');

        const inputAccess = form.querySelector('.access input[name="access"]');
        const inputAccessLabel = form.querySelector('#accessDropdown');
        const inputAccessVisual = form.querySelectorAll('.access .dropdown-item');

        const inputArticleTypeTrue = form.querySelector('.type input[name="article-type"]');
        const inputArticleTypesVisual = form.querySelectorAll('.type input[name="type[]"]');
        const inputArticleTypeLabel = form.querySelector('#typeDropdown');

        const inputInvestmentThemeTrue = form.querySelector('.theme input[name="theme"]');
        const inputInvestmentThemeTypesVisual = form.querySelectorAll('.theme input[name="themes[]"]');
        const inputInvestmentThemeLabel = form.querySelector('#themeDropdown');

        const inputCategory = form.querySelector('.search-tag input[name="category"]');
        const inputSearchTag = form.querySelector('.search-tag input[name="search-tag"]');
        const inputTagPillsContainer = form.querySelector('.search-tag .search-form__search-tag');
        const inputSearchTagClearButton = form.querySelector('#searchTagClear');
        const inputTagLabelDefault = form.querySelector('#tagValueLabelDefault');

        // Register layout switch triggers
        const layoutSwitches = form.querySelectorAll('.search-form__layout-switch');

        // Register mobile filters switch trigger
        const mobileSwitch = form.querySelector('.search-form__filters-switch');
        const clearAllFilters = form.querySelector('input[type="reset"]');
        const $clearAllFilters = $(clearAllFilters);

        // This list will be used as source to create ajax query
        const sourceInputs = [
            inputQuery,
            inputOrderBy,
            inputOrderDirection,
            inputDate,
            inputAccess,
            inputArticleTypeTrue,
            inputInvestmentThemeTrue,
            inputCategory,
            inputSearchTag,
        ];

        const updateBreadcrumbs = function(value) {
            if(!breadcrumbsContainer) {
                return;
            }

            const currentItem = breadcrumbsContainer.querySelector('.breadcrumb-item.active');

            if(!currentItem) {

                if(value.toString().length)
                {
                    breadcrumbsContainer.innerHTML += `<span class="breadcrumb-item active">${value.toString()}</span>`;
                }
                return;
            }

            if(value.toString().length) {
                return currentItem.innerText = value.toString();
            }

            currentItem.remove();
        };

        // Register all elements handles
        const handleOrderChange = function() {
            if (typeof this.dataset.order !== 'undefined') {
                inputOrderBy.value = this.dataset.order;
            }

            if (typeof this.dataset.orderDir !== 'undefined') {
                inputOrderDirection.value = this.dataset.orderDir;
            }

            form.querySelector('.order .dropdown-item.current').classList.remove('current');
            this.classList.add('current');

            inputOrderLabel.innerText = this.innerText;
        };

        const handleDateChange = function() {
            if (typeof this.dataset.date !== 'undefined') {
                inputDate.value = this.dataset.date;
            }

            form.querySelector('.date .dropdown-item.current').classList.remove('current');
            this.classList.add('current');

            inputDateLabel.innerText = this.innerText;
        };

        const handleAccessChange = function() {
            if (typeof this.dataset.access !== 'undefined') {
                inputAccess.value = this.dataset.access;
            }

            form.querySelector('.access .dropdown-item.current').classList.remove('current');
            this.classList.add('current');

            inputAccessLabel.innerText = this.innerText;
        };

        const handleMultipleSelect = function(trueInput, visualSelector, label, returnSimulated = false) {
            let activeFilters = [];
            let lastActiveLabel = '';

            visualSelector.forEach(function(input) {
                if(input.checked) {
                    activeFilters.push(input.value);
                    lastActiveLabel = input.nextElementSibling.innerText;
                }
            });

            if (returnSimulated) {
                return activeFilters.join(',');
            }

            if (!activeFilters.length || activeFilters.length === visualSelector.length) {
                // if none or all are active, then we dont need to filter anythingy
                trueInput.value = '';
                label.innerText = label.dataset.allPlaceholder;
                return;
            }

            trueInput.value = activeFilters.join(',');

            if (activeFilters.length === 1) {
                // only one value active atm
                label.innerText = lastActiveLabel;
                return;
            }

            // more than one, but less than all active
            label.innerText = label.dataset.multiplePlaceholder;
        };

        const handleArticleTypesChange = function() {
            handleMultipleSelect(
                inputArticleTypeTrue,
                inputArticleTypesVisual,
                inputArticleTypeLabel
            );
        };

        const handleInvestmentThemeChange = function () {
            handleMultipleSelect(
                inputInvestmentThemeTrue,
                inputInvestmentThemeTypesVisual,
                inputInvestmentThemeLabel
            );
        };

        const handleSearchTagClear = function () {
            inputTagLabelDefault.classList.remove('d-none');
            inputTagLabelDefault.classList.add('d-block');
            inputTagPillsContainer.classList.add('d-none');

            inputSearchTag.value = '';
            inputCategory.value = '';
        };

        const handleLayoutSwitch = function() {
            const context = this;

            layoutSwitches.forEach(function(layoutSwitch) {
                layoutSwitch.classList.toggle('current', layoutSwitch.dataset.type === context.dataset.type);
            });

            if (resultsList) {
                resultsList.classList.toggle('results-list--tiles', context.dataset.type === 'tiles');
                resultsList.classList.toggle('results-list-tiles--four', context.dataset.type === 'tiles');
                resultsList.classList.toggle('results-list--list', context.dataset.type === 'list');
            }
        };

        // Ajax call stuff
        const buildFilteringQueryString = function() {
            const data = [];

            sourceInputs.forEach(function(sourceInput) {
                if (!sourceInput || !sourceInput.value.length || !sourceInput.name.length) {
                    return;
                }

                data.push(`${sourceInput.name}=${sourceInput.value}`);
            });

            return encodeURI(data.sort().join('&'));
        };

        const ajaxCall = function(event, data) {
            updateBreadcrumbs(inputQuery.value);

            document.querySelectorAll('.results-list__item').forEach(function (element, index) {
                element.classList.remove('on-screen');
            });

            window.jQuery.ajax({
                method: 'POST',
                url: window.location
            }).done(function(responseContent, responseStatus, rawResponse) {
                if(rawResponse.status === 200 && responseContent.results && responseContent.totalRecords) {
                    return applyResults(responseContent);
                }

                return applyEmptyResult();
            });
        };

        const applyResults = function({firstTaken, lastTaken, results, totalPages, totalRecords, pagination, keywords = []}) {
            if (resultsList) {
                resultsList.innerHTML = results;
            }

            if (paginationContainer && pagination) {
                paginationContainer.innerHTML = pagination;
            }

            document.querySelectorAll('.results-list__item').forEach(function (element, index) {
                window.setTimeout(() => element.classList.add('on-screen'), 10 * index);
                window.setTimeout(() => element.classList.add('triggered'), 20 * index);
            });
        };

        const applyEmptyResult = function() {
            if (resultsList) {
                resultsList.innerHTML = '';
            }

            if (paginationContainer) {
                paginationContainer.innerHTML = '';
            }
        };

        const applyPresetFilters = function() {
            // 1. Apply sort order
            let orderByMatch = null;

            inputOrderByVisual.forEach(function(selector) {
                if (selector.dataset.order === inputOrderBy.value && selector.dataset.orderDir === inputOrderDirection.value) {
                    orderByMatch = selector;

                    form.querySelector('.order .dropdown-item.current').classList.remove('current');
                    selector.classList.add('current');
                }
            });

            if (inputOrderLabel) {
               inputOrderLabel.innerHTML = orderByMatch ? orderByMatch.innerHTML : inputOrderLabel.dataset.labelPlaceholder;
            }

            // 2. Apply articles date
            let dateMatch = null;

            inputDateVisual.forEach(function(selector) {
                if(selector.dataset.date === inputDate.value) {
                    dateMatch = selector;

                    form.querySelector('.date .dropdown-item.current').classList.remove('current');
                    selector.classList.add('current');
                }
            });

            if (inputDateLabel) {
                inputDateLabel.innerHTML = dateMatch ? dateMatch.innerHTML : inputDateLabel.dataset.labelPlaceholder;
            }

            // 3. Apply access type
            let accessMatch = null;

            inputAccessVisual.forEach(function(selector) {
                if(selector.dataset.access === inputAccess.value) {
                    accessMatch = selector;

                    form.querySelector('.access .dropdown-item.current').classList.remove('current');
                    selector.classList.add('current');
                }
            });

            if (inputAccessLabel) {
                inputAccessLabel.innerHTML = accessMatch ? accessMatch.innerHTML : inputAccessLabel.dataset.labelPlaceholder;
            }

            // 4. Apply type of article
            const selectedTypes = inputArticleTypeTrue ? inputArticleTypeTrue.value.split(',') : [];

            inputArticleTypesVisual.forEach(function(input) {
                const prevState = input.checked;

                input.checked = selectedTypes.indexOf(input.value) !== -1;

                if (prevState !== input.checked) {
                    input.dispatchEvent(new Event('change'));
                }
            });

            // 5. Apply investment theme
            const selectedThemes = inputInvestmentThemeTrue ? inputInvestmentThemeTrue.value.split(',') : [];

            inputInvestmentThemeTypesVisual.forEach(function(input) {
                const prevState = input.checked;

                input.checked = selectedThemes.indexOf(input.value) !== -1;

                if (prevState !== input.checked) {
                    input.dispatchEvent(new Event('change'));
                }
            });
        };

        const shouldFetchResults = function () {
            if(!form || !window.location) {
                return false;
            }

            let location = window.location.href;

            if (window.location.search) {
                location = window.location.href.replace(window.location.search, '');
            }

            return location === form.action;
        };

        // register event listeners
        if(inputOrderBy && inputOrderDirection && inputOrderLabel && inputOrderByVisual) {
            $(inputOrderByVisual).on('click', handleOrderChange);
        }

        if(inputDate && inputDateLabel && inputDateVisual) {
            $(inputDateVisual).on('click', handleDateChange);
        }

        if(inputAccess && inputAccessLabel && inputAccessVisual) {
            $(inputAccessVisual).on('click', handleAccessChange);
        }

        if(inputArticleTypeTrue && inputArticleTypesVisual && inputArticleTypeLabel) {
            $(inputArticleTypesVisual).on('change', handleArticleTypesChange);
        }

        if(inputInvestmentThemeTrue && inputInvestmentThemeTypesVisual && inputInvestmentThemeLabel) {
            $(inputInvestmentThemeTypesVisual).on('change', handleInvestmentThemeChange);
        }

        if (inputCategory && inputSearchTag && inputTagPillsContainer && inputSearchTagClearButton && inputTagLabelDefault) {
            $(inputSearchTagClearButton).on('click', handleSearchTagClear);
        }

        if(layoutSwitches) {
            $(layoutSwitches).on('click', handleLayoutSwitch);
        }

        // APPLY PRESET FILTERS
        applyPresetFilters();

        // BOOTSTRAP RELEVANCE SORT HANDLING
        let shouldModifySortOrder = false;

        // if (inputQuery && inputOrderBy) {
        //     shouldModifySortOrder = !inputQuery.value.length && inputOrderBy.value !== 'relevance';
        // }

        // REGISTER AJAX VALUES SUBMIT
        $form.on('submit', function(event) {
            event.preventDefault();

            // If there is query string - change sort filter to 'relevance'
            if(shouldModifySortOrder && inputQuery.value.length && inputOrderBy.value !== 'relevance') {
                let relevanceTrigger = Array.from(inputOrderByVisual).find(element => element.dataset.order === 'relevance');

                if (typeof relevanceTrigger !== 'undefined') {
                    inputOrderBy.value = 'relevance';
                    inputOrderDirection.value = 'desc';

                    inputOrderByVisual.forEach(element => element.classList.remove('current'));
                    relevanceTrigger.classList.add('current');
                    inputOrderLabel.innerText = relevanceTrigger.innerText.trim();

                    // But do it only once, any next choice is up to the user
                    shouldModifySortOrder = false;
                }
            }

            const queryString = buildFilteringQueryString();
            const url = form.action + (queryString ? `?${queryString}` : '');

            if (window.location.href !== url) {
                // Move only if there is real change
                window.location = url;
            }
        });

        $clearAllFilters.on('click', function() {
            inputOrderBy.value = '';
            inputDate.value = '';
            inputAccess.value = '';
            inputInvestmentThemeTrue.value = '';
            inputArticleTypeTrue.value = '';
            handleSearchTagClear();
            applyPresetFilters();
        });

        // CALL FOR RESULTS IF ITS RESULTS PAGE
        if (shouldFetchResults()) {
            ajaxCall();
        }
    };

    $('.search-form__mobile-filters').on('click', function() {
        this.classList.toggle('active');
        document.getElementById('search-form').classList.toggle('show');
    });

    window.addEventListener('load', searchHandler);
})(jQuery);